package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.addQueryParam
import com.fsryan.foundation.net.client.queryParamValues

abstract class WMOccupationsAndYearBoundRequestBuilder<B: WMOccupationsAndYearBoundRequestBuilder<B>>(
    yearBoundsRequired: Boolean = true
): WMYearBoundRequestBuilder<B>(yearBoundsRequired = yearBoundsRequired) {

    private val occupationIds = mutableListOf<Int>()

    fun addOccupationId(occupationId: Int): B {
        occupationIds.add(occupationId)
        return self()
    }

    override fun applyFrom(request: FSRequest<Nothing>): B {
        occupationIds.clear()
        request.queryParamValues("o").mapNotNull { it.toIntOrNull() }.forEach(occupationIds::add)
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        removeQueryParams(WMOccupationStatsRequestBuilder.QUERY_PARAM_OCCUPATION_ID)
        with(self()) {
            occupationIds.forEach {
                addQueryParam("o", it.toString())
            }
        }
        return super.build()
    }

    override fun clear(): B {
        occupationIds.clear()
        return super.clear()
    }
}
